import { SeoFooter } from 'components/SeoFooter'
import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`

  ${up('sm')} {
    padding-bottom: 120px;
  }
`

export const Footer: ComponentType = () => (
  <Wrapper className="print--none">
    <SeoFooter compact />
  </Wrapper>
)
